$('.l-header-fullScreenMenu__inner').click(function () {
  // $(this).parent().siblings().removeClass('is-current');
  $(this).parent().toggleClass('is-open');
});

$('.l-header-fullScreenMenu-more__inner').click(function () {
  $(this).parent().toggleClass('is-open');
});